import styles from './../_songPage.module.scss'
import songStyles from '../../../../components/_song.module.scss'

import artists from '../../../../utils/songs/artists'
import { albumPath } from '../../../../utils/routeHelpers'
import { CSSProperties, useContext, useEffect, useState } from 'react'
import SongVideo from './SongVideo'
import { t } from '../../../../utils'
import { PlayerContext } from '../../../../utils/song_player'
import AddToSetList from '../../../../components/AddToSetList'
import FavoriteSong from '../../../../components/FavoriteSong'
import classNames from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPause, faPlay } from '@fortawesome/free-solid-svg-icons'
import { useAuth } from '../../../../utils/auth'
import Image from 'next/legacy/image'
import { Song } from '../../../../__generated__/graphql'

const SongHeader: React.FC<{
  song: Song
  isPlaying: boolean
  setIsPlaying: (value: boolean) => void
  mixerIsPlaying: boolean
}> = ({ song, setIsPlaying, isPlaying, mixerIsPlaying }) => {
  const {
    playerState: { player, isLoading },
    playOrPause,
    stop
  } = useContext(PlayerContext)

  const playerSong = { id: song.id, url: song.sampleUrl }

  const { isAuthenticated } = useAuth()

  const [hover, setHover] = useState(false)
  const [isSongHeaderVisible, setIsSongHeaderVisible] =
    useState(!isAuthenticated)

  const hasPlayButton =
    player.isPaused(playerSong) || !player.isActiveSong(playerSong)

  const button = () => {
    if (player.isActiveSong(playerSong) && isLoading) return '...'

    if (hasPlayButton && !isPlaying) {
      return <FontAwesomeIcon icon={faPlay} />
    } else {
      return <FontAwesomeIcon icon={faPause} />
    }
  }

  useEffect(() => {
    if (mixerIsPlaying) {
      stop()
    }
  }, [mixerIsPlaying])

  useEffect(() => {
    setInterval(() => {
      if (!player.ensureIsPlaying()) {
        setIsPlaying(false)
      }
    }, 1000)
  }, [])
  const songStyle = {
    opacity: isSongHeaderVisible ? 'initial' : 0
  } as CSSProperties

  return (
    <article style={songStyle} className={styles.songArticle}>
      <div className="columns">
        <div className="column is-one-third">
          <div className={styles.songDetails}>
            <article
              onMouseOver={() => setHover(true)}
              onMouseOut={() => setHover(false)}
              className={classNames(songStyles.song, {
                [songStyles.isHovered]: hover
              })}
            >
              <div className={`songContainer ${songStyles.songContainer}`}>
                <figure>
                  <div className="is-square">
                    <div className={styles.songAvatar}>
                      <Image
                        src={song.album.cover.medium}
                        alt={song.title}
                        layout="fill"
                        width={280}
                        height={280}
                      />
                    </div>
                    {isAuthenticated && (
                      <ul className={songStyles.songActions}>
                        <li>
                          <AddToSetList song={song} />
                        </li>
                        <li>
                          <FavoriteSong song={song} />
                        </li>
                      </ul>
                    )}
                  </div>

                  <figcaption>
                    <button
                      className={songStyles.play}
                      onClick={() => {
                        playOrPause(playerSong)
                        setIsPlaying(!isPlaying)
                      }}
                    >
                      {button()}
                    </button>
                  </figcaption>
                </figure>
              </div>
            </article>

            <div className={styles.songDetailsDescription}>
              <h1>{song.title}</h1>
              <h2>
                {artists(song)} |{' '}
                <a href={albumPath(song.album)}>{song.album.name}</a>
              </h2>

              <table>
                <tbody>
                  <tr>
                    <td>{t('KEY')}</td>
                    <td>
                      <span className={styles.keyLabel}>{song.key}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>{t('BPM')}</td>
                    <td>{song.bpm}</td>
                  </tr>
                  <tr>
                    <td>{t('TIME SIG')}</td>
                    <td>{song.timeSignature}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <SongVideo
          song={song}
          setIsPlaying={setIsPlaying}
          setIsSongHeaderVisible={setIsSongHeaderVisible}
          mixerIsPlaying={mixerIsPlaying}
        />
      </div>
    </article>
  )
}

export default SongHeader
